import { useMemo, useRef } from 'react';
import { MessageContainerKey, MessageManager, MessageOptions } from '../message';
import { ToastComponent, ToastComponentProps } from './Toast';

interface ToastShowProps extends MessageOptions<ToastComponentProps> {
  root?: HTMLElement | null;
}

export function useToast() {
  const messageManager = useRef<MessageManager<ToastComponentProps>>();
  const currentRoot = useRef<HTMLElement>();
  const toast = useMemo(() => {
    if (typeof window === 'undefined') {
      return { show: () => {}, destroy: () => {} };
    }
    return {
      show(props: ToastShowProps) {
        if (props.root && props.root !== currentRoot.current) {
          currentRoot.current = props.root;
          messageManager.current = new MessageManager({
            component: ToastComponent,
            type: 'toast',
            root_container: props.root,
          });
          messageManager.current?.show(props);
        } else if (props.root && props.root === currentRoot.current) {
          messageManager.current?.show(props);
        } else {
          MessageManager.getInstance('toast').show(props);
        }
      },
      destroy(id: string, key?: MessageContainerKey) {
        if (messageManager.current) {
          messageManager.current.destroy(id, key);
        } else {
          MessageManager.getInstance('toast').destroy(id, key);
        }
      },
    };
  }, []);
  return toast;
}
